// extracted by mini-css-extract-plugin
export default {"container":"RecordManagementPolicyPage_container__EfZH-"};